<template>
    <base-modal @close="$emit('close')">
        <div
            slot="header"
            class="h3"
        >
            Sélectionner les dossiers auquels seront envoyés le mail
        </div>

        <div slot="body">
            <base-table
                :loading="!idLoaded && loading"
                :items="items"
                :meta="meta"
                :params="exParams"
                :head="head"
                no-export
                @orderBy="orderBy"
                @change-page="goToPage"
            >
                <div slot="before">
                    <div class="row ">
                        <div class="col-8 my-auto">
                            <base-select
                                v-model="type_id"
                                :options="optionsMailsTypes"
                            >
                                Sélectionner un type de mail
                            </base-select>
                        </div>
                        <div class="col-4 text-right my-auto">
                            <div
                                class="text-secondary h4 font-weight-bold"
                                title="Nombre de dossiers sélectionnés possédants un email associé"
                            >
                                {{ mailsSelected.length }} {{ 'dossier' | plural(mailsSelected.length) }}
                            </div>
                        </div>
                    </div>
                </div>

                <tr
                    v-for="dossier of items"
                    :key="dossier.id"
                >
                    <td>
                        <input
                            type="checkbox"
                            :value="dossier.id"
                            :checked="selectedDossiers[dossier.id]"
                            @click="changeChecked(dossier.id)"
                        >
                    </td>
                    <td>
                        <template v-if="dossier.client.is_indivision">
                            {{ dossier.client.type_indivision }} {{ dossier.client.libelle_indivision }}
                        </template>

                        <template v-else>
                            {{ dossier.client.nom }} {{ dossier.client.prenom }}
                        </template>
                    </td>

                    <td>{{ dossier.client.email }}</td>

                    <td class="text-center">
                        <router-link
                            :to="{name: 'dossier', params: {id: dossier.id}}"
                            class="btn btn-primary btn-sm"
                            title="Voir"
                            target="_blank"
                        >
                            <i class="fa fa-glasses" />
                        </router-link>
                    </td>
                </tr>

                <div slot="no-results">
                    <div class="text-center h3 mt-5 pt-5">
                        Aucun mail à envoyer...
                    </div>
                </div>
            </base-table>
        </div>

        <div slot="footer">
            <div
                v-if="items && items.length > 0"
            >
                <button
                    class="btn btn-success"
                    :disabled="!type_id"
                    @click="confirmInit"
                >
                    Rédiger mail
                </button>
            </div>
        </div>
    </base-modal>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import DossierSearch from "../../mixins/DossierSearch"
    import BaseTable from "../templates/BaseTable"
    import BaseSelect from "../templates/BaseSelect"
    import {mapGetters} from "vuex"

    export default {
        name: "SelectionDossiersDeClientsModal",

        components: {BaseTable, BaseModal, BaseSelect},

        mixins: [DossierSearch],

        props: {
            additionalParams: {type: Object, default: () => {return {}}},
            exercice: {type: Number, default: null},
            type: {type: String, default: null},
        },

        data: function () {
            const paginate = Math.round((window.innerHeight-400)/40)

            return {
                params: {
                    ...this.additionalParams,
                    actif: 1,
                    clientSorti: 0,
                    dossierSorti: 0,
                    emailRequired: 1,
                    paginate: paginate > 0 ? paginate : 1
                },

                selectedDossiers: [],

                head: {
                    checked: '',
                    client: 'Client',
                    email: 'Email',
                },

                idLoaded: false,

                type_id: 0,
            }
        },

        computed: {
            ...mapGetters(['optionsMailsTypes']),

            mailsSelected: function() {
                let result = []
                this.selectedDossiers.forEach((value, id) => {
                    if (value) {
                        result.push(id)
                    }
                })

                return result
            }
        },

        created() {
            axios.get('/api/dossiers/only-id', { params: this.params})
                .then((data)=> {
                    data.data.data.forEach((dossier) => Vue.set(this.selectedDossiers, dossier.id, true))
                })
                .catch(() => this.$notify('danger', 'Une erreur est survenue lors du chargement des dossiers.'))
                .finally(() => this.idLoaded = true)
        },

        methods: {
            changeChecked: function (id) {
                Vue.set(this.selectedDossiers, id, !this.selectedDossiers[id])
            },

            confirmInit: function() {
                if (this.type === 'prospect') {
                    this.$confirm('Vous vous apprêtez à générer un envoi massif de mails. Confirmez-vous cet envoi ?')
                        .then(() => this.$emit('next-step', { dossiersId: this.mailsSelected, type_id: this.type_id }))
                } else {
                    this.$confirm('Vous vous apprêtez à générer un envoi massif de mails aux clients de l\'exercice « ' + this.exercice + ' ». Confirmez-vous cet envoi ?')
                        .then(() => this.$emit('next-step', { dossiersId: this.mailsSelected, type_id: this.type_id }))
                }
            },
        }
    }
</script>
